/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Complete_TitleInputs */

const en_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice Complete`)
};

const de_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung abgeschlossen`)
};

const fr_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice terminé`)
};

const es_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Práctica completada`)
};

const it_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercitazione completata`)
};

const nl_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefening voltooid`)
};

const pl_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenie zakończone`)
};

const fi_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoitus suoritettu`)
};

const da_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelse fuldført`)
};

const sv_interview_practice_complete_title = /** @type {(inputs: Interview_Practice_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Övning avslutad`)
};

/**
* | output |
* | --- |
* | "Practice Complete" |
*
* @param {Interview_Practice_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_complete_title = /** @type {((inputs?: Interview_Practice_Complete_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Complete_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_complete_title(inputs)
	if (locale === "fr") return fr_interview_practice_complete_title(inputs)
	if (locale === "es") return es_interview_practice_complete_title(inputs)
	if (locale === "it") return it_interview_practice_complete_title(inputs)
	if (locale === "nl") return nl_interview_practice_complete_title(inputs)
	if (locale === "pl") return pl_interview_practice_complete_title(inputs)
	if (locale === "fi") return fi_interview_practice_complete_title(inputs)
	if (locale === "da") return da_interview_practice_complete_title(inputs)
	if (locale === "sv") return sv_interview_practice_complete_title(inputs)
	return en_interview_practice_complete_title(inputs)
});